(function(window, document) {
  'use strict';

  function trim(value) {
    return String(value || '').replace(/^\s+|\s+$/g, '');
  }

  function onReady(callback) {
    if (!callback) return;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }
    callback();
  }

  function parseJson(text) {
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function normalizeBaseUrl(value) {
    var raw = trim(value);
    var origin = window.location.protocol + '//' + window.location.host;

    if (!raw) return origin;
    if (raw.indexOf('http://') === 0 || raw.indexOf('https://') === 0) return raw.replace(/\/+$/, '');
    if (raw.indexOf('//') === 0) return window.location.protocol + raw.replace(/\/+$/, '');
    if (raw.charAt(0) === '/') return (origin + raw).replace(/\/+$/, '');
    return (window.location.protocol + '//' + raw).replace(/\/+$/, '');
  }

  function getPsBaseUrl() {
    if (window.paintscratchTheme && window.paintscratchTheme.psUrl) {
      return normalizeBaseUrl(window.paintscratchTheme.psUrl);
    }
    return normalizeBaseUrl('');
  }

  function getHostname(url) {
    var parser = document.createElement('a');
    parser.href = url;
    return (parser.hostname || '').toLowerCase();
  }

  function createAllowedHostMap() {
    var hosts = {};
    var currentHost = (window.location.hostname || '').toLowerCase();
    var psHost = getHostname(getPsBaseUrl());

    if (currentHost) hosts[currentHost] = true;
    hosts['www.paintscratch.com'] = true;
    hosts['hub.paintscratch.com'] = true;
    if (psHost) hosts[psHost] = true;

    return hosts;
  }

  function normalizeDestinationUrl(url) {
    var parser = document.createElement('a');
    parser.href = url || '';
    return parser.href || '';
  }

  function isAllowedDestination(url, allowedHosts) {
    var normalized = normalizeDestinationUrl(url);
    var parser = document.createElement('a');
    var host;
    var protocol;

    parser.href = normalized;
    protocol = (parser.protocol || '').toLowerCase();
    host = (parser.hostname || '').toLowerCase();

    if (protocol !== 'https:') return false;
    if (!host) return false;

    return !!allowedHosts[host];
  }

  function requestJson(url, payload, callback) {
    var xhr = new XMLHttpRequest();

    xhr.open('POST', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.onreadystatechange = function() {
      var data;

      if (xhr.readyState !== 4) return;

      data = parseJson(xhr.responseText || '');
      if (!data || typeof data !== 'object') data = {};

      callback(xhr.status >= 200 && xhr.status < 300, xhr.status, data);
    };
    xhr.onerror = function() {
      callback(false, 0, {});
    };
    xhr.send(JSON.stringify(payload));
  }

  function submitHiddenForm(destination) {
    var form = document.createElement('form');
    var fields = destination && destination.fields ? destination.fields : {};
    var method = trim(destination && destination.method ? destination.method : 'POST').toUpperCase();
    var key;
    var input;

    if (method !== 'GET' && method !== 'POST') method = 'POST';

    form.method = method;
    form.action = destination.url;
    form.style.display = 'none';

    for (key in fields) {
      if (!Object.prototype.hasOwnProperty.call(fields, key)) continue;
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = fields[key] == null ? '' : String(fields[key]);
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  }

  function initFindOrder(root) {
    var form = root.querySelector('[data-ps-form]');
    var statusEl = root.querySelector('[data-ps-status]');
    var submitBtn = root.querySelector('[data-ps-submit]');
    var numberInput = root.querySelector('[data-ps-input="number"]');
    var emailInput = root.querySelector('[data-ps-input="email"]');
    var phoneInput = root.querySelector('[data-ps-input="phone"]');
    var methodInputs = root.querySelectorAll('[data-ps-input="method"]');
    var emailWrap = root.querySelector('[data-ps-email-wrap]');
    var phoneWrap = root.querySelector('[data-ps-phone-wrap]');
    var endpointUrl = getPsBaseUrl() + trim(root.getAttribute('data-ps-order-lookup-path'));
    var allowedHosts = createAllowedHostMap();
    var state = {
      submitting: false
    };

    function getMethod() {
      var index;
      for (index = 0; index < methodInputs.length; index += 1) {
        if (methodInputs[index].checked) return methodInputs[index].value;
      }
      return 'email';
    }

    function hideNode(node) {
      if (!node) return;
      node.setAttribute('hidden', 'hidden');
    }

    function showNode(node) {
      if (!node) return;
      node.removeAttribute('hidden');
    }

    function setStatus(kind, message) {
      if (!statusEl) return;
      statusEl.className = statusEl.className.replace(/\bis-success\b|\bis-error\b|\bis-info\b/g, '').replace(/\s{2,}/g, ' ');
      statusEl.textContent = trim(message);

      if (!trim(message)) {
        statusEl.style.display = 'none';
        return;
      }

      statusEl.className += ' is-' + kind;
      statusEl.style.display = 'block';
    }

    function clearStatus() {
      setStatus('info', '');
    }

    function setInlineError(fieldName, message) {
      var input = root.querySelector('[data-ps-input="' + fieldName + '"]');
      var error = root.querySelector('[data-ps-error-for="' + fieldName + '"]');

      if (input) {
        input.className = input.className.replace(/\bis-error\b/g, '').replace(/\s{2,}/g, ' ');
        if (trim(message)) input.className += ' is-error';
      }

      if (error) {
        error.textContent = trim(message);
        error.className = error.className.replace(/\bis-visible\b/g, '').replace(/\s{2,}/g, ' ');
        if (trim(message)) error.className += ' is-visible';
      }
    }

    function clearInlineErrors() {
      setInlineError('number', '');
      setInlineError('email', '');
      setInlineError('phone', '');
    }

    function setSubmitting(isSubmitting) {
      state.submitting = !!isSubmitting;
      if (submitBtn) submitBtn.disabled = state.submitting;
    }

    function syncMode() {
      var method = getMethod();
      var submitLabel = root.getAttribute('data-ps-submit-label') || 'Find order';

      clearInlineErrors();

      if (method === 'email') {
        showNode(emailWrap);
        hideNode(phoneWrap);
      } else {
        hideNode(emailWrap);
        showNode(phoneWrap);
      }

      if (submitBtn) submitBtn.textContent = submitLabel;
    }

    function normalizeNumber(value) {
      return trim(value).replace(/^#/, '');
    }

    function validate() {
      var isValid = true;
      var method = getMethod();
      var emailValue = trim(emailInput && emailInput.value);
      var phoneValue = trim(phoneInput && phoneInput.value);
      var emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      clearInlineErrors();

      if (!normalizeNumber(numberInput && numberInput.value)) {
        setInlineError('number', 'Enter your order or invoice number.');
        isValid = false;
      }

      if (method === 'email') {
        if (!emailValue) {
          setInlineError('email', 'Enter the email used on the order.');
          isValid = false;
        } else if (!emailReg.test(emailValue)) {
          setInlineError('email', 'Enter a valid email address.');
          isValid = false;
        }
      } else {
        if (!phoneValue) {
          setInlineError('phone', 'Enter the phone number used on the order.');
          isValid = false;
        }
      }

      return isValid;
    }

    function buildPayload() {
      var payload = {
        number: normalizeNumber(numberInput && numberInput.value),
        verification: {}
      };
      var method = getMethod();

      if (numberInput) numberInput.value = payload.number;

      if (method === 'email') {
        payload.verification.method = 'email';
        payload.verification.email = trim(emailInput && emailInput.value);
      } else {
        payload.verification.method = 'phone';
        payload.verification.phone = trim(phoneInput && phoneInput.value);
      }

      return payload;
    }

    function handleDestination(destination) {
      var blockedMessage = root.getAttribute('data-ps-navigation-error') || 'We found the order, but could not open the destination securely. Please contact support.';
      var normalizedUrl;

      if (!destination || !destination.url || !destination.type) {
        setStatus('error', blockedMessage);
        return;
      }

      normalizedUrl = normalizeDestinationUrl(destination.url);
      if (!isAllowedDestination(normalizedUrl, allowedHosts)) {
        setStatus('error', blockedMessage);
        return;
      }

      destination.url = normalizedUrl;
      setStatus('info', 'Taking you to your order...');

      if (destination.type === 'redirect') {
        window.location.assign(destination.url);
        return;
      }

      if (destination.type === 'post') {
        submitHiddenForm(destination);
        return;
      }

      setStatus('error', blockedMessage);
    }

    function handleLookupResponse(ok, statusCode, data) {
      var fallbackError = root.getAttribute('data-ps-generic-error') || 'We could not verify that information. Check your details or try another verification method.';

      setSubmitting(false);

      if (ok && data && data.verified && data.destination) {
        handleDestination(data.destination);
        return;
      }

      if (statusCode === 0) {
        setStatus('error', 'Network error. Please try again.');
        return;
      }

      setStatus('error', trim(data && data.error) || fallbackError);
    }

    function sendLookupRequest(payload) {
      clearStatus();
      setSubmitting(true);
      requestJson(endpointUrl, payload, handleLookupResponse);
    }

    function onSubmit(event) {
      if (event && event.preventDefault) event.preventDefault();
      clearStatus();

      if (!validate()) return false;

      sendLookupRequest(buildPayload());
      return false;
    }

    if (!form || !submitBtn || !numberInput) return;

    numberInput.addEventListener('blur', function() {
      numberInput.value = normalizeNumber(numberInput.value);
    });

    form.addEventListener('submit', onSubmit);

    if (methodInputs && methodInputs.length) {
      var index;
      for (index = 0; index < methodInputs.length; index += 1) {
        methodInputs[index].addEventListener('change', function() {
          clearStatus();
          syncMode();
        });
      }
    }

    syncMode();
  }

  onReady(function() {
    var roots = document.querySelectorAll('[data-ps-find-order-root]');
    var index;

    for (index = 0; index < roots.length; index += 1) {
      initFindOrder(roots[index]);
    }
  });
})(window, document);
